const decodeHtmlEntities = (value: string) =>
  value
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");

export const toWordPreview = (value: string, wordLimit = 20) => {
  const plain = decodeHtmlEntities(String(value || ""))
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!plain) {
    return "";
  }

  const words = plain.split(" ");
  if (words.length <= wordLimit) {
    return plain;
  }

  return `${words.slice(0, wordLimit).join(" ")}...`;
};
